module.exports = __webpack_public_path__ + "static/media/murugeshramachandran.9adb116c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/murugeshramachandran.webp
// module id = 644
// module chunks = 0